import { getAllDeveloper, createDeveloper, updateDeveloper, removeDeveloper } from '@/services/api'

export default {
  state: {
    allDeveloper: [], // 开发商列表
  },

  effects: {
    *getAllDeveloper(_, { call, put }) {
      const res = yield call(getAllDeveloper)
      yield put({
        type: 'saveAllDeveloper',
        payload: res,
      })
    },
    *remove({ payload }, { call, put }) {
      yield call(removeDeveloper, payload)
      yield put({
        type: 'getAllDeveloper',
        payload: payload,
      })
    },
    *createDeveloper({ payload }, { call, put }) {
      yield call(createDeveloper, payload)
      yield put({
        type: 'getAllDeveloper',
        payload: payload,
      })
    },
    *updateDeveloper({ payload }, { call, put }) {
      yield call(updateDeveloper, payload)
      yield put({
        type: 'getAllDeveloper',
        payload: payload,
      })
    },
  },

  reducers: {
    saveAllDeveloper(state, { payload }) {
      return { ...state, allDeveloper: payload }
    },
  },
}
